// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1kX79","appDark":"App_appDark__3heA-"};